import { toast } from 'react-hot-toast';
import { setBlurLoading, setToken } from '../../redux/slices/authSlice';
import { setLoading as setProfileLoading } from '../../redux/slices/profileSlice';
import { apiConnector } from '../apiconnector';
import { setUser } from '../../redux/slices/profileSlice';
import { profileEndpoints } from '../apis';

const {
    USERDETAIL_API,
    UPDATE_PROFILE_PICTURE_API,
    UPDATE_PROFILE_API,
    DELETE_ACCOUNT_API,
    UPDATE_NAME_API,
    GET_USER_ENROLLED_COURSES_API,
    GET_INSTRUCTORE_DETAIL_API,
} = profileEndpoints;

export const userDetail = async () => {
    try {
        const response = await apiConnector("GET", USERDETAIL_API);
        if (!response.data.success) {
            return toast.error(response.data.message);
        }
        return response;
    } catch (error) {
        console.log('User Detail API error => ', error.message);
    }
};

export const profilePictureUpload = (formData) => {
    return async (dispatch) => {
        dispatch(setProfileLoading(true));
        try {
            const profilePictureResponse = await apiConnector('PUT', UPDATE_PROFILE_PICTURE_API, formData);
            if (!profilePictureResponse.data.success) {
                return toast.error(profilePictureResponse.data.message);
            }

            try {
                const userDetailsResponse = await userDetail();
                if (!userDetailsResponse.data.success) {
                    return toast.error(profilePictureResponse.data.message);
                }
                dispatch(setUser(userDetailsResponse.data.user));
                localStorage.setItem('user', JSON.stringify(userDetailsResponse.data.user));
            } catch (error) {
                toast.error('Live reload failed, please log in again');
            }
            toast.success('Profile Picture Updated');
        } catch (error) {
            toast.error('Profile Picture Updatation Failed');
        } finally {
            dispatch(setProfileLoading(false));
        }
    };
};

export const updateProfile = (profileData) => {
    return async (dispatch) => {
        dispatch(setBlurLoading(true));
        try {
            const updateProfileResponse = await apiConnector("PUT", UPDATE_PROFILE_API, profileData);
            if (!updateProfileResponse.data.success) {
                return toast.error(updateProfileResponse.data.message);
            }
            await apiConnector("PUT", UPDATE_NAME_API, {
                firstName: profileData.firstName,
                lastName: profileData.lastName
            });
            const updatedUserDetailsResponse = await userDetail();
            if (!updatedUserDetailsResponse.data.success) {
                return toast.error(updatedUserDetailsResponse.data.message);
            }
            dispatch(setUser(updatedUserDetailsResponse.data.user));
            localStorage.setItem('user', JSON.stringify(updatedUserDetailsResponse.data.user));
            toast.success('Profile Updated');
        } catch (error) {
            toast.error('Profile updation failed. Please try again or contact us.');
        } finally {
            dispatch(setBlurLoading(false));
        }
    };
};

export const deleteAccount = (navigate) => {
    return async (dispatch) => {
        dispatch(setBlurLoading(true));
        try {
            const response = await apiConnector('DELETE', DELETE_ACCOUNT_API);
            if (!response.data.success) {
                return toast.error(response.data.message);
            }
            dispatch(setToken(null));
            dispatch(setUser(null));
            localStorage.removeItem('token');
            localStorage.removeItem('user');
            toast.success(response.data.message);
            navigate('/');
        } catch (error) {
            toast.error('Account Deletion failed. Please try again or contact us', { duration: 3000 });
        } finally {
            dispatch(setBlurLoading(false));
        }
    };
};

export const getAllUserEnrolledCourse = (setEnrolledCoursesData, setLoading) => {
    return async () => {
        setLoading(true);
        try {
            const response = await apiConnector("GET", GET_USER_ENROLLED_COURSES_API);
            if (!response.data.success) {
                return toast.error(response.data.message);
            }
            setEnrolledCoursesData(response.data.enrolledCourses);
        } catch (error) {
            console.log('Error in fetching enrolled courses API: ', error.message);
        } finally {
            setLoading(false);
        }
    };
};

export const getInstructorDetail = (instructorId, setInstructor, setConfirmationModal, setLoading) => {
    return async () => {
        setLoading(true);
        try {
            const response = await apiConnector("POST", GET_INSTRUCTORE_DETAIL_API, { instructorId });
            if (!response.data.success) {
                setConfirmationModal({
                    text1: 'Instructor Detail Problem',
                    text2: response.data.message,
                    closeModal: () => setConfirmationModal(null),
                });
            } else {
                let instructor = response.data.instructorDetails;
                let totalStudent = 0;
                let reviews = [];
                for (const course of instructor.courses) {
                    totalStudent += course.studentsEnrolled.length > 0 ? course.studentsEnrolled.length : 0;
                    course.ratingAndReviews.length > 0 &&
                        course.ratingAndReviews.flatMap((review) => reviews.push(review));
                }
                instructor = { ...instructor, totalStudent, reviews };
                setInstructor(instructor);
            }
        } catch (error) {
            console.log('Error while fetching instructor details: ', error.message);
        } finally {
            setLoading(false);
        }
    };
};